import React, {Component} from "react";
import {
    Field,
    reduxForm,
    getFormValues,
    getFormSubmitErrors,
} from "redux-form";
import {connect} from "react-redux";
import {Link} from "react-router-dom";

import {ROUTESLIST} from "@/static/urls";
import DatePickerField from "@/components/forms/date-picker";
import SelectField from '@/components/forms/select-field';
import {
    arrangeData,
    convertDateToDb,
} from "@/middlewares/api";
import "./index.scss";
import FormField from "@/components/forms/form-field";

class DigitalLicenseStep4 extends Component {
    constructor(props) {
        super(props);
        this.stepSubmit = this.stepSubmit.bind(this);
        this.goBack = this.goBack.bind(this);
    }

    goBack() {
        const {prevStep, rawValues} = this.props;
        prevStep(rawValues);
    }

    stepSubmit(data) {
        let formData = arrangeData(data);
        formData.deadline = convertDateToDb(formData.deadline);
        if (data.type_of_used === "master" || data.type_of_used === "both") {
            formData.master_sampled_used = 1;
        }
        if (data.type_of_used === "publish" || data.type_of_used === "both") {
            formData.publishing_sampled_used = 1;
        }
        delete formData.type_of_used;

        // Pass data to wizard, tidak perlu API call karena cart/checkout flow
        this.props.onSubmit(formData);
        return Promise.resolve();
    }

    render() {
        const {handleSubmit, submitting, savingAll} =
            this.props;
        return (
            <form
                onSubmit={handleSubmit((data) => {
                    return this.stepSubmit(data);
                })}
                className="form-layout"
                noValidate
            >
                <div className="form-row">
                    <div className="form-col_2">
                        <Field
                            name="format"
                            required={true}
                            options={[
                                {id: "digital", name: "Digital"},
                                //"digital", "physical", "both"
                                {id: "physical", name: "Physical"},
                                {id: "both", name: "Both"}
                            ]}
                            component={SelectField}
                            label="Format"
                        />
                    </div>
                    <div className="form-col_2">
                        <Field
                            name="amount"
                            component={FormField}
                            required={true}
                            type="text"
                            label="Amount of product you’ll manufacture (recommended 1,000)"
                        />
                    </div>
                </div>

                <div className="form-row">
                    <div className="form-col_2">
                        <Field
                            name="upc_catalog"
                            component={FormField}
                            required={true}
                            type="text"
                            label="UPC/catalog #"
                        />
                    </div>
                    <div className="form-col_2">
                        <Field
                            name="ISRC"
                            component={FormField}
                            required={true}
                            type="text"
                            label="ISRC"
                        />
                    </div>
                </div>


                <div className="form-row">
                    <div className="form-col_2">
                        <Field
                            name="time"
                            component={FormField}
                            required={true}
                            type="text"
                            label="Running Time of Your Song"
                        />
                    </div>
                    <div className="form-col_2">
                        <Field
                            name="release_date"
                            component={DatePickerField}
                            placeholder="enter MM/DD/YY"
                            label="Intended Release Date"
                        />
                    </div>
                </div>
                <div className="submit-row_txt">
                    <p className="as-text">
                        By clicking Next button you are agreeing to the
                        <Link
                            to={ROUTESLIST.STATIC_TERMS}
                            className="link-thin"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Terms and Conditions.
                        </Link>
                    </p>
                </div>
                <div className="submit-row submit-row_txt">
                    <button
                        className="btn btn-second"
                        onClick={this.goBack}
                        type="button"
                    >
                        Back
                    </button>
                    <button
                        className="btn-red-primary"
                        disabled={submitting || savingAll}
                        type="submit"
                    >
                        Finish & Send
                    </button>
                </div>
            </form>
        );
    }
}

const validate = (values) => {
    const errors = {};
    if (!values.deadline) errors.deadline = "Preferred License Deadline is required";
    return errors;
};

const DigitalLicenseStep4Form = reduxForm({
    form: "digital-license-step4",
    enableReinitialize: true,
    validate
})(DigitalLicenseStep4);

const mapState = (state) => {
    const errors = getFormSubmitErrors("digital-license-step4")(state);
    return {
        rawValues: getFormValues("digital-license-step4")(state),
        radioFieldsError:
            errors.master_sampled_used || errors.publishing_sampled_used
                ? "Sample Used is required."
                : null,
    };
};
export default connect(mapState)(DigitalLicenseStep4Form);